import { getPagesCount } from '../../shared/utils/get-pages-count';
import { RequestWrap } from '../models/request-wrap';

export interface Entities<Tmodel> {
  entities: { [id: string]: Tmodel }
  ids: string[]
  totalPages: number
  totalCount: number
}

export function generateEntities(data: RequestWrap<any>, property = '_id') {
  if (!data)
    return {
      ids: [],
      entities: {},
      totalPages: 1,
      totalCount: 0
    }
  const items = data.results

  const ids = items.map(p => p[property])
  const entities = items.reduce(
    (itemsMap: { [id: string]: any }, item: any) =>
      Object.assign(itemsMap, {
        [item[property]]: item
      })
    ,
    {}
  )

  return {
    ids,
    entities,
    totalPages: getPagesCount(data.totalCount),
    totalCount: data.totalCount
  }
}

export function parseEntities(entities: {[id: string]: any}): any {
  if (!entities)
    return []
  return entities && Object.keys(entities).map(id => entities[id])
}
